export default __webpack_public_path__ + "static/media/08.6f81a439.png";